<template>
  <!-- 回答 -->
  <answer 
    v-if="msg.chatType === CHAT_TYPE.ANSWER"
    :lastMsg="lastMsg"
    :isWaitAnswer="isWaitAnswer"
    :show-portrait="fullscreen"
    :fullscreen="fullscreen"
    :msg="msg"
    @resend="val => $emit('resend', val)"
    @submit="(data)=>$emit('submit', data)"
    @scrollToEnd="$emit('scrollToEnd')"/>
  <!-- 提问 -->
  <question 
    v-else-if="msg.chatType === CHAT_TYPE.QUESTION"
    :show-portrait="fullscreen"
    :fullscreen="fullscreen"
    :msg="msg"/>
  <div v-else class="system-msg">{{ msg.content }}</div>
</template>

<script>
import { CHAT_TYPE } from '../const';
import Answer from './answer.vue';
import Question from './question.vue';
export default {
  name: 'AiRobotMessage',
  components: {
    Answer,
    Question
  },
  props: {
    isWaitAnswer: {
      type: Boolean,
      default: false
    },
    msg: {
      type: Object,
      default: () => {}
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    lastMsg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      CHAT_TYPE
    };
  }
};
</script>
